export default class DtoNetworkLink {
    constructor(obj = {}) {
        this.idStation = obj.idStation
        this.idNetwork = obj.idNetwork
        this.startDate = obj.startDate
        this.endDate = obj.endDate
    }
}